export function OptionMenuItem({ children, onClick }: { children: React.ReactNode, onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }) { 
    return (
        <button
            onClick={onClick}
            className="flex gap-x-1 items-center hover:bg-gray-200 rounded-[4px] py-[6px] cursor-pointer px-[6px] w-full">
            {children}
        </button>
    );
}